export default __webpack_public_path__ + "static/media/miguel-lopes-43.842b295e.jpg";